export const environment = {
  production: false,
  apiUrl: 'https://dev.docker.api.deskcenter.mycena.co/',
  socketUrl: 'dev.docker.socket.api.deskcenter.mycena.co',
  reverbAppKey: '256aefe24dfb90a7ebbc',
  recaptchaKey: '6Le_veMUAAAAAPtECwl1XL65KopbaQt-46U5ayuG',
  videoUrl: 'https://dw2pwyfakchst.cloudfront.net/videos/',
  defaultLang: 'en',
  documentationUrl: 'https://dev.docker.documentation.mycena.co/docs/',
  desktopVersionLink: {
    windows: {
      msi: 'https://update.deskcenter.mycena.co/download/windows_64/dev-docker/mycenaDeskCenter.msi',
      exe: 'https://update.deskcenter.mycena.co/download/windows_64/dev-docker/mycenaDeskCenter.exe',
    },
    linux: 'https://update.deskcenter.mycena.co/download/linux_64/dev-docker',
    mac: {
      intel: 'https://update.deskcenter.mycena.co/download/osx_64/dev-docker',
      arm: 'https://update.deskcenter.mycena.co/download/osx_arm64/dev-docker'
    }
  },
  extensionVersionLink: {
    chrome: "https://chrome.google.com/webstore/detail/myce-na-desk-center-extens/ihmaefbmifmbbcobcnfbgofllgbjbfpn",
    firefox: "https://mycena.co/firefox/"
  }
};
